import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Subject, timer } from 'rxjs';
import { IvFormComponent } from '../../../../shared/components/iv-form/iv-form.component';
import {
  AuthTokenCheckRequest,
  Cert,
  CertListAvailableRequest,
  IvSignService,
  OperationService,
  MetadataOperation,
  Certinfo,
} from '../../../../api';
import { ProfileService } from '../../../../core/profile/profile.service';
import { TranslateService } from '../../../../core/translation';
import { MessageService } from '../../../../shared/message/message.service';
import { SignatureXadesRequest } from '../../../../api/model/signatureXadesRequest';
import { operationTypeEnum } from '../../../../models/operation-type';
import { MassiveSignature } from '../../../../api/model/massiveSignature';
import { CertLoadedService } from '../../../../base/services/cert/cert-loaded.service';
import { certConfig, loginConfig } from '../../../../modules/signature/ivsign/form/config';
import { HttpClient } from '@angular/common/http';
import { PersonalizationsService } from '../../../../base/services/personalizations/personalizations.service';
import { Environment } from '../../../../models/environment';
import { FinishProService } from '../../../services/finish-pro.service';
import SignaturePad from 'signature_pad';
import { SamlService } from '../../../../services/saml.service';
import { Router } from '@angular/router';
import { take, takeUntil } from 'rxjs/operators';
import { PadesInitMFSRequest } from '../../../../api/model/padesInitMFSRequest';
import { FinalizeDistributePadesMFSRequest } from '../../../../api/model/finalizeDistributePadesMFSRequest';
import { SigSocketService } from '../../../../base/services/websockets/sigsocket.service';
import { PadesInitMFSResponse } from '../../../../api/model/padesInitMFSResponse';
import { InitSignDataToSign } from '../../../../api/model/initSignDataToSign';
import { WebSocketSubject } from 'rxjs/webSocket';

@Component({
  selector: 'app-ivsignpro',
  templateUrl: './ivsignpro.component.html',
  styleUrls: ['./ivsignpro.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [IvSignService, HttpClient, OperationService],
})
export class IvSignProComponent implements OnInit, OnDestroy, AfterViewInit, OnDestroy {
  @ViewChild('SignaturePad') signaturePad: SignaturePad;
  /**
   * IvForm component from platform.
   */
  @ViewChild('ivform') ivform: IvFormComponent;

  /**
   * String containing the id  of the customization.
   */
  @Input() appID: string;

  /**
   * Boolean with the signature status (show/hide).
   */
  @Input() showSignDoc = false;

  /**
   * Number that controls the signatures number.
   */
  @Input() firmasDoc = 0;

  /**
   * Obteins graffic sign value
   */
  @Input() signGraffic: number;

  /**
   * Array that contains the widgets in pdf.
   */
  @Input('widgetSign') Widget: any[];

  /**
   * Object that contains operation id.
   */
  @Input() operationId: any;

  /**
   * Boolean that allows/blocks the multiple signature.
   */
  @Input() multiple = false;

  /**
   * Boolean that checks if user is external.
   */
  @Input() external = false;

  /**
   * Boolean that allow/block changing signature type.
   */
  @Input() allowChange = false;

  @Input() multipleSign: boolean = false;

  /**
   * Event triggered when user signs a pdf.
   */
  @Output() SendDocuments: EventEmitter<any> = new EventEmitter();

  /**
   * Event triggered when user signs various pdfs.
   */
  @Output() onMultipleSignStart: EventEmitter<any> = new EventEmitter();

  /**
   * Event triggered when finish the multiple signature.
   */
  @Output() onMultipleFinish: EventEmitter<any> = new EventEmitter();

  /**
   * Event triggered when dialog is closed.
   */
  @Output() onModalClose: EventEmitter<any> = new EventEmitter();

  /**
   * Event triggered when there's an error.
   */
  @Output() onError: EventEmitter<any> = new EventEmitter();

  /**
   * Event triggered when user selects multiple pdfs.
   */
  @Output() onMultipleCheck: EventEmitter<any> = new EventEmitter();

  /**
   * Event triggered when user hasn't a certificate.
   */
  @Output() onNoCert: EventEmitter<any> = new EventEmitter();

  @Output() onLoadFinish: EventEmitter<boolean> = new EventEmitter();

  /**
   * String that contains the certificate in b64.
   */
  certb64 = '';

  /**
   * Boolean that shows/hides that receivers list are empty.
   */
  hidePassword = true;

  /**
   * Boolean that controls if signature is working.
   */
  signing = false;

  /**
   * Array that contains the pdfs.
   */
  pdfs: any[] = [];

  /**
   * Array that contains the signed pdfs.
   */
  pdfsSigned: any[] = [];

  /**
   * Object containing the form distribution.
   */
  loginForm: any = { ...loginConfig };

  /**
   * Object containing the form distribution.
   */
  certForm: any = { ...certConfig };

  massiveSignature: MassiveSignature = {};

  /**
   * Object containing button labels and title errors.
   */
  botonesForm: { label: string; active: boolean }[] = [
    { label: '', active: false },
    { label: '', active: true },
  ];

  /**
   * Object containing the Ivsign token.
   */
  tokenIvSign: string = null;

  /**
   * Object containing the Ivsign token copy.
   */
  tokenIvSignCopy: string = null;

  /**
   * Boolean that controls if user is logged.
   */
  isLogged = false;

  /**
   * Object containing the data of the certificate.
   */
  listCerts: CertListAvailableRequest = {
    caller: { host: 'string', app: 'string', location: 'string', remoteuser: 'string' },
    cert: { expired: false },
    date: new Date(),
  };

  /**
   * Array that contains the certificates.
   */
  certList: any[] = [];

  /**
   * Object containing the data of the pdf and signature.
   */
  SignPades: PadesInitMFSRequest = {};

  /**
   * Object containing the data of the pdf and signature.
   */
  SignXades: SignatureXadesRequest = {};

  /**
   * String that contains the signature in b64.
   */
  signature: string;

  /**
   * String that contains the pin of the certificate.
   */
  certpin: string;

  /**
   * Boolean that controls if token has been checked.
   */
  checkTokenBoolen = false;

  /**
   * Number that controls the relation between signatures and pdfs.
   */
  signed = 0;

  /**
   * Object containing the data of the certificate.
   */
  json: any = {};

  /**
   * Object containing the function of a timer.
   */
  timer: any;

  /**
   * Object containing the data of the signature.
   */
  signData: any = {};

  /**
   * Object containing the data of the signature process.
   */
  dataMultiple: any = {};

  /**
   * Object containing the modal.
   */
  modal: any = null;

  /**
   * Object containing error labels.
   */
  errorMessages: any = {
    required: '',
  };

  /**
   * Object containing the modalof multiple signature.
   */
  dialogMultiple: any;

  /**
   * Object containing the session token.
   */
  token: string = this._profile.getToken();

  /**
   * Object containing the data of selected certificate.
   */
  selectedCert: Cert;

  /**
   * Object containing the configuration of the signature.
   */
  signer: any;

  /**
   * Object containing the configuration of the signature.
   */
  configSign: any;

  /**
   * Boolean that controls if multiple signature is working.
   */
  multipleSignInProgress = false;

  /**
   * Boolean that controls if multiple signature is finished.
   */
  multipleSignFinish = false;

  /**
   * String that contains the id of the task.
   */
  processId = '';

  /**
   * Array that contains the incidences of the process.
   */
  incidences: any[];

  /**
   * Boolean that controls if the list of certificates is ready.
   */
  listLoaded = false;

  /**
   * Number that controls the progress of the massive signature.
   */
  progressBar: any = 0;

  /**
   * Number that controls the type of template loaded.
   */
  display = 0;

  /**
   * String that contains the IvDesk token.
   */
  ivDeskToken: string = null;

  /**
   * Object containing the loaded form.
   */
  form: any;

  /**
   * Boolean that shows / hides the template.
   */
  showTemplate = true;

  /**
   * Boolean that controls if there's a certificate.
   */
  noCert = false;

  /**
   * Boolean that controls if the view is loaded.
   */
  afterView = false;

  /**
   * String that contains the IvDesk url.
   */
  ivDeskLink: string;

  /**
   * String for setting the IvSign dialog width
   */
  ivSignModalWidth: string;

  /**
   * String for setting the IvDesk dialog width
   */
  IvDeskModalWidth: string = window.innerWidth > 992 ? '30vw' : '75vw';

  /**
   * String that contains the html label to charge the IvDesk link.
   */
  ivDeskLinkHtml: string;

  /**
   * Object containing the image of signature.
   */
  image: any;

  _transParam: boolean = false;

  /**
   * Array for the pdf form fields data
   */
  metadataDocument: Array<MetadataOperation> = [];

  /**
   * String that contains the actual value of
   */
  customText: string = null;

  /**
   * String that contains the actual name of the cert preselected
   */
  valCertLoad: string;

  valOrgaId: string = '';

  messageError: string;

  showErrorMessage: boolean = false;

  environment: Environment;

  operationType: string;

  ivDeskSign: boolean = false;

  titleDialog: string = '';

  localSign: boolean = false;

  onlyLoginSAMLSIG: boolean;

  hasBothSigns: boolean = true;

  tokenSAML: string;

  cifCert: string = '';

  needAuth: boolean = false;

  websockets: WebSocketSubject<any>;

  routeQR: string = '';

  destroy$: Subject<boolean> = new Subject<boolean>();

  signPadesResponse: PadesInitMFSResponse;

  isNewMetadata: boolean = true;

  firstLoad: boolean = true;

  constructor(
    public _router: Router,
    public _ivSignService: IvSignService,
    public _operationService: OperationService,
    private _profile: ProfileService,
    private _translate: TranslateService,
    private _message: MessageService,
    private _certLoaded: CertLoadedService,
    public _finishPro: FinishProService,
    public _samlService: SamlService,
    private _sigSocketService: SigSocketService,
    private _personalization: PersonalizationsService
  ) {
    this.operationType = this._finishPro.getOperationType();
    this.titleDialog = this._translate.instant('signaturit_pro.signComponent.sign_cert2_' + this.operationType);
    this.environment = this._personalization.sendEnv;
    this.onlyLoginSAMLSIG = this.environment.features?.onlyLoginSAMLSIG;
    this.ivDeskSign = this.environment.signature.external ? true : false;
    this.appID = this.environment.appid;
    this.ivDeskLink = this.environment?.features.ivDeskUrl || 'https://ivdesk.ivsign.net/';
    const modalWidth = this.environment?.features.ivSignModalWidth
      ? this.environment?.features.ivSignModalWidth
      : '100%';
    this.ivSignModalWidth = window.innerWidth > 992 ? modalWidth : 'auto';
    this.ivDeskLinkHtml =
      '<a class="primary-color font-weight-bold" href="' +
      this.ivDeskLink +
      '" target="_blank" title="IvDesk">IvDesk</a>';
    this.localSign = this.environment.signature._default === 2 && this.environment.signature.external ? true : false;
    this.hasBothSigns = this.environment.signature.external && this.environment.signature._internal;
  }

  ngOnInit(): void {
    this.resetConfigCert();
    this.setToken();
    this.setForm();
    this.fillForm();
    if (this.environment.signature._internal) {
      this.checkLogin();
      this.loadTemplate();
    }
    if (this.environment.features.textPopUpIvSign) {
      this.customText = this.environment.features.textPopUpIvSign;
    }
    this._translate.massTranslate(this.loginForm, 'label', 'ivsign_form_');
    this._translate.massTranslate(this.certForm, 'label', 'ivsign_form_');
    this.errorMessages.required = this._translate.instant('form_error_required');
    this.botonesForm[0].label = this._translate.instant('btn_limpiar');
    this.botonesForm[1].label = this._translate.instant('btn_guardar');
    if (!this.tokenIvSign) {
      this.tokenIvSign = this._certLoaded.getTokenCert();
    }
    this.hasCertLoaded();
  }

  ngAfterViewInit(): void {
    this.setForm();
    this.disableSelector();
    this.validateOrgaId();
    this.afterView = true;
  }

  /**
   * Function that sets data of pdf, operation and widget.
   * @param {any} data Object that contains data .
   */
  setData(data: any): void {
    this.pdfs = data.pdfs;
    this.operationId = data.id;
    this.Widget = data.widget;
    this.signGraffic = data.signGraffic;
    this.operationType = data.operationType;
  }

  changeSign(): void {
    this.localSign = !this.localSign;
    this._finishPro.isLocalSign = this.localSign;
  }

  /**
   * Function that sets the type of form.
   */
  setForm(): void {
    if (!this.form) {
      this.form = this.tokenIvSign
        ? this.certForm
        : !this.environment.features.onlyLoginSAMLSIG
          ? this.loginForm
          : this.multipleSign
            ? this.loginForm
            : null;
    }
    this.display = this.tokenIvSign ? 2 : 1;
  }

  fillForm(): void {
    if (document.cookie) {
      const cookieName = this.getCookie('username');
      this.loginForm.username.value = cookieName;
      if (!loginConfig.username.value) {
        loginConfig.username.value = '';
      }
      const cookieCompany = this.getCookie('companyName');
      this.loginForm.orgaid.value = cookieCompany;
      if (!loginConfig.orgaid.value) {
        loginConfig.orgaid.value = '';
      }
    }
  }

  getCookie(name: string): string {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }

    return null;
  }

  /**
   * Function that hides the template.
   */
  disableView(): void {
    this.showTemplate = false;
  }

  /**
   * Function that shows the template.
   */
  loadView(): void {
    this.showTemplate = true;
  }

  ngOnDestroy(): void {
    this.image = null;

    if (this._sigSocketService.isConnected()) {
      this._sigSocketService.closeWebSocket();
    }
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  /**
   * Function that sets the IvSign token.
   * @param {string} token String containing the session token.
   */
  setToken(token?: string): void {
    const tokenSAML = this.getTokenSAML();
    this.tokenIvSign = tokenSAML
      ? tokenSAML.split('-').join('+').split('_').join('/')
      : (this.tokenIvSignCopy = token || this._profile.getUserProperty('tokenIvSign'));
    this._samlService.tokenIvSign.emit(this.tokenIvSign);
    this._samlService.hasTokenSAML.emit(tokenSAML ? true : false);
  }

  getTokenSAML(): string {
    if (this._finishPro.tokenSAML) {
      this.tokenSAML = this._finishPro.tokenSAML;
    } else {
      const route = this._router.parseUrl(decodeURIComponent(this._router.url));
      this.tokenSAML = route.queryParams['token'];
    }

    if (this.tokenSAML) {
      switch ((this.tokenSAML.length - 1) % 4) {
        case 0:
          // No pad chars in this case
          break;
        case 2:
          // Two pad chars
          this.tokenSAML += '==';
          break;
        case 3:
          // One pad char
          this.tokenSAML += '=';
          break;
      }
    }

    return this.tokenSAML;
  }

  /**
   * Function that checks if there's an IvSign token.
   */
  checkLogin(): void {
    if (this.tokenIvSign) {
      const authObject: AuthTokenCheckRequest = {
        token: this.tokenIvSign,
      };
      this._ivSignService
        .ivSignPostTokenCheck(authObject)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            if (!response.result) {
              this._profile.removeUserProperty('tokenIvSign');
            }
          },
          (error) => {
            this.emitError(error);
          }
        );
    }
  }

  /**
   * Function that obtains the url for the massive signature.
   * @param {string} operationId String that contains operation id.
   * @param {Function} callback Function triggered when finish the server petition.
   */
  getExternalUrl(operationId: string[], callback?: Function): void {
    this._operationService
      .operationPostUrlSignMultipleOperation(operationId, this.token || '1')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          callback(response.data);
        },
        (error) => {
          this.emitError(error);
        }
      );
  }

  /**
   * Function that checks if form is valid.
   */
  checkIfValid(): boolean {
    return this.ivform.Form && this.ivform.Form.valid;
  }

  /**
   * Function that loads the view.
   * @param {number} display Number that controls the type of template loaded.
   */
  loadTemplate(display?: number): void {
    if (this.external && !this.environment.signature._internal) {
      return;
    }
    if (!display) {
      if (this.tokenIvSign) {
        this.getCertList();
      }
      return;
    }
    this.display = display;
    switch (display) {
      case 1:
        this.ivform.updateForm(this.loginForm);
        break;
      case 2:
        this.ivform.updateForm(this.certForm);
        this.getCertList();
        break;
    }
  }

  /**
   * Function that logins in IvSign
   * @param {any} val Object that contains the form configuration.
   * @param {Function} callback Function triggered when finish the server petition.
   */
  login(val: any = this.ivform.Form.value, callback?: Function): void {
    const data: any = {
      module: '1',
      authmethod: 'pass',
      login: val.username,
      pass: val.password,
      orgaid: val.orgaid,
    };
    if (!val.username || !val.password) {
      this.ivform.Form.markAllAsTouched();
      this.ivform.Form.updateValueAndValidity();
      this.emitError('');
      return;
    }

    this.showErrorMessage = false;

    this._ivSignService.ivSignPostLogin(data).subscribe(
      (response) => {
        if (response.error && response.error.code != 'K0000') {
          this.isLogged = false;
          this.emitError(response);
          this._profile.removeUserProperty('tokenIvSign');
        } else {
          this._profile.setUserProperty('tokenIvSign', response.token);

          this.tokenIvSign = this.tokenIvSignCopy = response.token;
          if (this._profile.getUser()) {
            this._profile.setUserProperty('tokenIvSign', response.token);
          }
          this.isLogged = true;
          if (callback) {
            callback();
          }
          if (this.showTemplate) {
            this.loadTemplate(2);
          }
        }
      },
      (error) => {
        this.emitError(error);
        this._profile.removeUserProperty('tokenIvSign');
      }
    );
  }

  /**
   * Function that obtains the certificates list.
   * @param {Function} callback Function triggered when finish the server petition.
   */
  getCertList(callback?: Function): void {
    this._ivSignService
      .ivSignPostCertListAvailable(this.listCerts, 'Bearer ' + this.tokenIvSign)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          const orgaConfig = JSON.parse(localStorage.getItem('orgaConfig'));
          const certLabel = orgaConfig?.certLabel || 'descr';
          const property = certLabel;

          this.operationType = this._finishPro.getOperationType();
          if (this.operationType === operationTypeEnum.SIGQSCD) {
            response.data.certlist = response.data.certlist.filter((res) => res.qscd && res.qualified);
          }

          this.certForm.cert.options = response.data.certlist?.map((option) => {
            return { label: option[property] || option.subjectcn, value: option };
          });
          this.noCert = !(this.certForm.cert.options && this.certForm.cert.options.length);
          if (this.noCert) {
            this.onNoCert.emit();
          }
          if (callback) {
            callback(this.certForm.cert.options);
          }

          this.onLoadFinish.emit(false);
        },
        (error) => {
          this.emitError(error);
        }
      );
  }

  /**
   * Function that controls signing pdf.
   * @param {any} value Object that contains the form configuration.
   * @param {Function} callback Function triggered when finish the server petition.
   */
  async sign(value: any = this.ivform?.Form.value, callback?: Function): Promise<void> {
    const d = value;
    if (!d?.cert || (!d?.pin && !this.valCertLoad)) {
      this.ivform?.Form.markAllAsTouched();
      this.ivform?.Form.updateValueAndValidity();
      this.emitError('');
      return;
    }
    if (!this.valCertLoad) {
      this.selectedCert = d?.cert;
      this.selectedCert.pin = d?.pin;
    } else {
      this.selectedCert = this._certLoaded.getCompleteCert();
    }
    this.signing = true;
    if (this.multiple) {
      this.signMultiple();
      return;
    } else {
      if (d?.cert.needauth) {
        this.needAuth = true;
      }
    }
    this.getSignConfig(() => {
      this.SignDocuments();
    });
  }

  /**
   * Function that converts a image in b64 in a file.
   * @param {string} image String that contains the data of signature.
   */
  setSignature(image: string): void {
    this.image = image;
  }

  /**
   * Function that signs pdfs.
   */
  async SignDocuments(): Promise<void> {
    this.showErrorMessage = false;
    let signImage = null;
    if (this.signaturePad != undefined) {
      if (this.signaturePad.isEmpty()) {
        return;
      } else {
        signImage = this.signature.replace('data:image/jpeg;base64,', '').replace('data:image/jpeg;base64,', '');
      }
    } else if (this.image) {
      signImage = this.image;
    }
    if ((this.Widget != null && this.Widget != undefined && this.Widget.length != 0) || this.signGraffic === 1) {
      this.showSignDoc = true;
    } else {
      this.showSignDoc = false;
    }
    if (!this.firmasDoc) {
      this.firmasDoc = 0;
    }
    const offset = this.firmasDoc * 130 + 35;

    for (const pdf of this.pdfs) {
      const documentExtension = pdf.fileNameWithExtension.toLowerCase();

      if (documentExtension.endsWith('.pdf')) {
        this.SignPades = {
          request: {
            cert: this.selectedCert,
            document: 'sss',
            profile: 'enhanced',
            extensions: 't,timestamp,revinfo',
            hashalgorithm: '',
            parameters: {
              pdfparameters: {
                signvisible: this.showSignDoc,
                signbackgroundconfig: {
                  signback: signImage,
                  signbackautostretch: true,
                  transparencymask: {
                    red: 255,
                    green: 255,
                    blue: 255,
                    tolerance: 10,
                  },
                },
                widgetprops: {},
              },
            },
          },
          metadataDocument: this.metadataDocument,
        };
      }

      if (documentExtension.endsWith('.xml')) {
        this.SignXades = {
          request: {
            cert: this.selectedCert,
            document: 'sss',
            profile: 'enhanced',
            extensions: 't,timestamp,revinfo',
            hashalgorithm: '',
            envelop: '',
            references: [],
            force: false,
            operation: '',
            signdata: '',
          },
          metadataDocument: this.metadataDocument,
        };
      }
    }

    this.signed = 0;
    let promises = [];
    for (const pdf of this.pdfs) {
      const document = pdf.fileNameWithExtension.toLowerCase();

      if (document.endsWith('.pdf')) {
        this.SignPades.metadataDocument = [];
        this.SignPades.metadataDocument = [...this._finishPro.metaDataOperation];
        if (!this.signing) {
          break;
        }
        const widgetNumber = this.Widget.findIndex((widget) => widget.doc === pdf.idDocument);
        this.SignPades.request.parameters.pdfparameters.widgetprops = this.setWidgetConfig(offset, widgetNumber);
        if (this.configSign && this.signer) {
          for (const key in this.signer) {
            if (this.signer[key]) {
              this.SignPades.request.parameters.pdfparameters.widgetprops[key] = this.signer[key];
            }
          }
        }
        this.SignPades.request.document = pdf.b64;

        for (let index = 0; index < this.metadataDocument?.length; index++) {
          this.SignPades.metadataDocument.push({
            key: this.metadataDocument[index].key,
            value: this.metadataDocument[index].value,
          });
        }
        this.SignPades.metadataDocument.push({ key: 'idOperation', value: this.operationId });
        this.SignPades.metadataDocument.push({ key: 'idDocument', value: pdf.idDocument });
        if (this.json?.org) {
          this.validateCert(this.json);
        }
        if (this.cifCert) {
          this.SignPades.metadataDocument.push({ key: 'certificateCif', value: this.cifCert });
        }
        if (!this.needAuth) {
          promises.push(
            this._ivSignService.ivSignPostSignaturePades(this.SignPades, 'Bearer ' + this.tokenIvSign).toPromise()
          );
        }
      }

      if (document.endsWith('.xml')) {
        if (!this.signing) {
          break;
        }
        this.SignXades.metadataDocument.push({ key: 'idOperation', value: this.operationId });
        this.SignXades.metadataDocument.push({ key: 'idDocument', value: pdf.idDocument });
        this.SignXades.request.document = pdf.b64;
        const typeSignature =
          this._finishPro.operationRequest.typeSignature === '' ? null : this._finishPro.operationRequest.typeSignature;

        if (!this.needAuth) {
          promises.push(
            this._ivSignService
              .ivSignPostSignatureXades(this.SignXades, 'Bearer ' + this.tokenIvSign, typeSignature)
              .toPromise()
          );
        }
      }
    }

    if (!this.needAuth) {
      Promise.allSettled(promises).then((results) => {
        results.forEach((result, i) => {
          if (result.status === 'fulfilled') {
            this.pdfs[i].b64 = result.value.data.data;
            this.signed++;
          }

          if (result.status === 'rejected') {
            this.emitError(result.reason?.error?.error?.message);
            this.signing = false;
            this.signed = 0;
          }
        });

        if (this.pdfs.length == this.signed) {
          this.SendDocuments.emit(this.pdfs);
        }
      });
    }
  }

  /**
   * Function that signs pdfs.
   */
  async SignDocument(pdf): Promise<void> {
    if (!this.firmasDoc) {
      this.firmasDoc = 0;
    }
    const offset = this.firmasDoc * 130 + 35;
    const document = pdf.fileNameWithExtension.toLowerCase();

    if (document.endsWith('.pdf')) {
      this.SignPades.metadataDocument = [];
      this.SignPades.metadataDocument = [...this._finishPro.metaDataOperation];
      if (!this.signing) {
        return;
      }
      const widgetNumber = this.Widget.findIndex((widget) => widget.doc === pdf.idDocument);
      this.SignPades.request.parameters.pdfparameters.widgetprops = this.setWidgetConfig(offset, widgetNumber);
      if (this.configSign && this.signer) {
        for (const key in this.signer) {
          if (this.signer[key]) {
            this.SignPades.request.parameters.pdfparameters.widgetprops[key] = this.signer[key];
          }
        }
      }
      this.SignPades.request.document = pdf.b64;

      for (let index = 0; index < this.metadataDocument?.length; index++) {
        this.SignPades.metadataDocument.push({
          key: this.metadataDocument[index].key,
          value: this.metadataDocument[index].value,
        });
      }
      this.SignPades.metadataDocument.push({ key: 'idOperation', value: this.operationId });
      this.SignPades.metadataDocument.push({ key: 'idDocument', value: pdf.idDocument });
      if (this.json?.org) {
        this.validateCert(this.json);
      }
      if (this.cifCert) {
        this.SignPades.metadataDocument.push({ key: 'certificateCif', value: this.cifCert });
      }
    }

    if (document.endsWith('.xml')) {
      if (!this.signing) {
        return;
      }
      this.SignXades.metadataDocument.push({ key: 'idOperation', value: this.operationId });
      this.SignXades.metadataDocument.push({ key: 'idDocument', value: pdf.idDocument });
      this.SignXades.request.document = pdf.b64;
    }
  }

  /**
   * Function that obtains a certificate.
   */
  getCert() {
    if (JSON.parse(localStorage.getItem('cerdata_' + this.selectedCert.serial))) {
      this.json = JSON.parse(localStorage.getItem('cerdata_' + this.selectedCert.serial));
      this.generateCustomSign();

      return false;
    }
    const cert = { cert: { certid: this.selectedCert.certid } };

    if (!this.valCertLoad) {
      this._ivSignService
        .ivSignPostCertCerGet(cert, 'Bearer ' + this.tokenIvSign)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            this.parseCert(response.data.cer);
          },
          (error) => {
            this.emitError(error);
          }
        );
    } else {
      this.json = this._certLoaded.getParseCert();
      localStorage.setItem('cerdata_' + this.selectedCert.serial, JSON.stringify(this.json));
      this.generateCustomSign();
    }
  }

  /**
   * Function that converts a certificate in b64 in a object.
   * @param {string} certb64 String that contains the data of certificate.
   */
  parseCert(certb64?: string): void {
    const cert = { b64pk: certb64 };
    this._operationService
      .operationPostParseCertificate(cert, this.token || '1')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          this.json = response.data.certinfo;
          if (this.json) {
            localStorage.setItem('cerdata_' + this.selectedCert.serial, JSON.stringify(this.json));
          }
          this.generateCustomSign();
        },
        (error) => {
          this.emitError(error);
        }
      );
  }

  /**
   * Function that obtains the configuration of signature.
   * @param {Function} callback Function triggered when finish the server petition.
   */
  getSignConfig(callback: Function): void {
    this._operationService
      .operationGetOperationGraficConfig(this.operationId, this.token || '1')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          this.signer = {};
          if (!response.data.length) {
            callback();
          } else {
            this.configSign = JSON.parse(response.data)['captionsigner'][0];
            this.getCert();
          }
        },
        (error) => {
          if (error.status === 404) {
            this.signer = null;
            callback();
          } else {
            this.emitError(error);
          }
        }
      );
  }

  /**
   * Function that generate a configuration of signature.
   */
  generateCustomSign(): void {
    const c = this.configSign;

    for (const key in c) {
      let string = '';
      if (Array.isArray(c[key])) {
        for (let a = 0; a < c[key].length; a++) {
          for (const key2 in c[key][a]) {
            if (a != 0) {
              string += '\r\n';
            }
            if (this.json[key2]) {
              let t = key2.toUpperCase();
              if (key2.length > 2) {
                t = t.charAt(0);
              }
              string += t + '=';
            }
            if (c[key][a][key2] == '') {
              string += this.json[key2];
            } else if (this.json[key2]) {
              string += this.json[key2][c[key][a][key2]];
            }
          }
        }
      } else if (typeof c[key] === 'object') {
        for (const key2 in c[key]) {
          if (c[key][key2] == '') {
            if (this.json[key2]) {
              string += this.json[key2];
            }
          } else {
            let i = 0;
            if (this.json[key2]) {
              for (const key3 in c[key][key2]) {
                if (i != 0) {
                  string += ' ';
                }
                if (this.json[key2][key3]) {
                  string += this.json[key2][key3];
                }
                i++;
              }
            }
          }
        }
      }
      this.signer[key] = string;
    }
    if (this.needAuth) {
      this.checkMetadataMFSDynSig();
      this.webSocketConnection(0);
    } else {
      this.SignDocuments();
    }
  }

  checkMetadataMFSDynSig(): void {
    if (this._finishPro.isDynSig) {
      if (
        (this.operationType === operationTypeEnum.SIGQSCD || this.operationType === operationTypeEnum.SIG) &&
        this.isNewMetadata
      ) {
        this.isNewMetadata = false;
        this.metadataDocument.push({ key: 'SIG_TYPE', value: this.operationType });
        this._finishPro.metaDataOperation.push({ key: 'SIG_TYPE', value: this.operationType });
      }
    }
  }

  /**
   * Function that checks if pin of certificate is valid.
   */
  checkPin(): void {
    this._ivSignService
      .ivSignPostCertPinCheck(
        { cert: { certid: this.selectedCert.certid, pin: this.selectedCert.pin } },
        'Bearer ' + this.tokenIvSign
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          if (response.data.result === true) {
            this.signMultiple(true);
          } else {
            this.emitError(response);
          }
        },
        (error) => {
          this.emitError(error);
        }
      );
  }

  /**
   * Function that signs massive operations.
   * @param {boolean} state Boolean that contains if the pin of certificated is checked.
   */
  signMultiple(pinChecked?: boolean) {
    if (!pinChecked) {
      this.checkPin();
      return false;
    }

    this.massiveSignature.listMetadataOperation = [];
    this.massiveSignature.idOperation = this.operationId;
    this._operationService
      .operationPostMassiveSignature(
        this.massiveSignature,
        operationTypeEnum.SIG,
        this.token,
        this.selectedCert.certid,
        btoa(this.selectedCert.pin),
        'Bearer ' + this.tokenIvSign
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          this.processId = response.data;
          this.multipleSignInProgress = true;
          this.onMultipleSignStart.emit();
          this.checkMultipleSignState();
          this.modal.close();
        },
        (error) => {
          this.emitError(error);
        }
      );
  }

  /**
   * Function that checks the status of massive signatures.
   */
  checkMultipleSignState(): void {
    this.timer = timer(500, 1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe((t) => {
        this._operationService
          .operationGetCheckProcessMassiveSignature(this.processId, this.token)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (response) => {
              const data = (this.dataMultiple = response.data);
              this.dataMultiple.progressBar = Math.round((data.signDocs / data.totalDocs) * 100);
              this.dataMultiple.disabled = true;
              this.onMultipleCheck.emit(this.dataMultiple);
              if (data.finish === true) {
                this.timer.unsubscribe();
                this.multipleSignFinish = true;
                this.dataMultiple.progressBar = 100;
              }
            },
            (error) => {
              this.emitError(error);
            }
          );
      });
  }

  /**
   * Function triggered wuen there's an error.
   * @param {any} error Object that contains the form configuration.
   */
  emitError(error: any): void {
    this.onError.emit(error);
    this.messageError = this._message.renderError(error);
    this.showErrorMessage = true;
  }

  /**
   * Function that sets if the user is external.
   * @param {boolean} value Boolean that contains if the user is external.
   */
  setExternal(value: boolean): void {
    this.external = value;
  }

  /**
   * Function that sets if the signature is massive.
   * @param {boolean} value Boolean that contains if the signature is massive.
   */
  setMultiple(value: boolean): void {
    this.multiple = value;
  }

  /**
   * Function that sets if is posible changing the type of signature.
   * @param {boolean} value Boolean that contains if the signature is posible changing the type of signature.
   */
  setAllowChange(value: boolean): void {
    this.allowChange = value;
  }

  /**
   * Function that sets the html label to charge the IvDesk link.
   */
  getNotice(): string {
    let notice = '';
    if (this.allowChange) {
      notice +=
        this._translate.instant('external_signature_change') +
        ' <span class="primary-color">' +
        this._translate.instant(this.external ? 'ivsign_signature_centralized' : 'ivsign_signature_local') +
        '</span>';
    }
    return notice;
  }

  /**
   * Function that sets if the user is external.
   */
  onNoticeClick(): void {
    this.setExternal(!this.external);
    if (!this.external && (!this.certList || (this.certList && !this.certList.length))) {
      this.loadTemplate();
    }
  }

  /**
   * Function for setting the widget configutarion
   */
  setWidgetConfig(offset: number, widgetNumber: number) {
    let page = 'first';
    let width = 130;
    let height = 50;
    let posX = offset;
    let posY = 0;
    if (this.Widget != null && this.Widget != undefined && this.Widget.length != 0 && widgetNumber >= 0) {
      const widget = this.Widget[widgetNumber];
      const design = JSON.parse(widget.design);
      posX = Math.round(this.Widget[widgetNumber].positionX);
      posY = Math.round(this.Widget[widgetNumber].positionY);
      width = Math.round(design.width);
      height = Math.round(design.height);
      posX = Math.round(widget.positionX);
      posY = Math.round(widget.positionY);
      page = widget.page.toString();
    }
    const widget = {
      autopos: false,
      offsetx: posX,
      offsety: posY,
      autosize: false,
      width: width,
      height: height,
      rotate: 0,
      showonpages: page,
      widgetpageoffset: 0,
      hidetext: false,
      sizeheader: 5.5,
      sizedatetime: 4,
      sizetitlesection: 5,
      sizetextsection: 4.5,
    };

    return widget;
  }

  /**
   * Function that validates if has selected a default cert
   */
  hasCertLoaded(): void {
    this.valCertLoad = this._certLoaded.getNameCert();
    this.allowChange = false;
  }

  /**
   * Function that validates and disable default selectors of certificate
   */
  disableSelector(): void {
    if (this.valCertLoad) {
      this.certForm.cert.hidden = true;
      this.certForm.certSelected.hidden = false;
      this.certForm.pin.hidden = true;

      this.certForm.certSelected.value = this.valCertLoad;
      this.ivform.updateForm(this.certForm);

      this.ivform.Form.get('cert').patchValue(this.valCertLoad);
    }
  }

  /**
   * Function that resets the actual values of certLoad and tokenIvSign
   */
  resetConfigCert(): void {
    this.valCertLoad = '';
    this.tokenIvSign = '';
  }

  validateOrgaId(): void {
    this.valOrgaId = this.environment.features.orgaIdFinish
      ? this.environment.features.orgaIdFinish
      : this.environment.login.orgaID;
    if (this.valOrgaId) {
      this.ivform.Form.get('orgaid')?.patchValue(this.valOrgaId);
    }
  }

  validateCert(cert: Certinfo) {
    if (cert.org?.doc) {
      this.cifCert = cert.org.doc;
    }
  }

  webSocketConnection(indexPDF: number): void {
    this._sigSocketService.webSocketError.subscribe((error) => {
      const translateError = this._translate.instant(error);
      this.messageError = this._message.renderError(translateError);
      this.showErrorMessage = true;
      this.onLoadFinish.emit(false);
    });

    this.websockets = this._sigSocketService.activateWebSocket(this.operationId);

    this._sigSocketService
      .getConnectionStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((isConnected) => {
        if (!isConnected) {
        }
      });

    const successSubscription = this._sigSocketService.webSocketSuccess
      .pipe(take(1))
      .subscribe((success) => {
        if (success) {
          this.loadInitConfig(this.pdfs[indexPDF]);
          this.routeQR = window.location.href + '/redirectMFS?id=' + this.operationId;
          this.SignDocument(this.pdfs[indexPDF]);
          this.signAndValidateMFS();
        }
      });

    this.destroy$.pipe(take(1)).subscribe(() => successSubscription.unsubscribe());

    this.websockets.subscribe({
      next: (data) => {
        if (data.Type === 3) {
          const message = JSON.parse(data.Message);
          if (message.SendToParent && message.SendToParent.includes('Linked')) {
            this.finalizeMFS(indexPDF);
          }
        } else if (data.Type === 1) {
          const message = JSON.parse(data.Message);
          if (message.Type === 2) {
            this.finalizeMFS(indexPDF);
          }
        }
      },
      error: (err) => {
        console.error('Error en el WebSocket:', err);
        this.showErrorMessage = true;
        this.onLoadFinish.emit(false);
      },
    });
  }

  async signAndValidateMFS(): Promise<void> {
    this.SignPades['urlCallback'] = this.routeQR;
    try {
      const response = await this._ivSignService
        .ivSignPostInitSignMFSPades(this.SignPades, this.tokenIvSign)
        .toPromise();
      this.signPadesResponse = response.data;
      if (this.signPadesResponse.data) {
        this.finalizeMobile();
        return;
      }
      if (response) {
        if (response.data.initSignData.verificationAppUrl) {
          open(response.data.initSignData.verificationAppUrl, '_blank');
        } else {
          this.finalizeMFS(this.signed);
        }
      }
    } catch (error) {
      this.emitError(error);
    }
  }

  async finalizeMFS(pdf: number): Promise<void> {
    const initSignData: InitSignDataToSign = {
      twoFactor: {
        hashData: this.signPadesResponse.initSignData.hashData,
        transactionId: this.signPadesResponse.initSignData.transactionId,
      },
      sadPin: this.signPadesResponse.initSignData.sadPin,
    };
    const request: FinalizeDistributePadesMFSRequest = {
      certId: this.SignPades.request.cert.certid,
      initPadesData: this.signPadesResponse.initPadesData,
      initSignData: initSignData,
      metadataDocument: this.SignPades.metadataDocument,
    };
    try {
      const response = await this._ivSignService
        .ivSignPostSignAndFinalizeMFSPades(request, this._finishPro.operationId, this.tokenIvSign)
        .toPromise();
      if (response) {
        this.pdfs[pdf].b64 = response.data.data;
        this.signed++;
        this._sigSocketService.closeWebSocket();
        if (this.pdfs.length == this.signed) {
          this.SendDocuments.emit(this.pdfs);
        } else {
          this.webSocketConnection(this.signed);
        }
      }
    } catch (error) {
      this.emitError(error);
    }
  }

  finalizeMobile(): void {
    this.pdfs[this.signed].b64 = this.signPadesResponse.data;
    this.signed++;
    if (this.pdfs.length == this.signed) {
      this.SendDocuments.emit(this.pdfs);
    } else {
      this.webSocketConnection(this.signed);
    }
  }

  loadInitConfig(pdf): void {
    this.showErrorMessage = false;
    let signImage = null;
    if (this.signaturePad != undefined) {
      if (this.signaturePad.isEmpty()) {
        return;
      } else {
        signImage = this.signature.replace('data:image/jpeg;base64,', '').replace('data:image/jpeg;base64,', '');
      }
    } else if (this.image) {
      signImage = this.image;
    }
    if ((this.Widget != null && this.Widget != undefined && this.Widget.length != 0) || this.signGraffic === 1) {
      this.showSignDoc = true;
    } else {
      this.showSignDoc = false;
    }
    if (!this.firmasDoc) {
      this.firmasDoc = 0;
    }

    const documentExtension = pdf.fileNameWithExtension.toLowerCase();
    if (documentExtension.endsWith('.pdf')) {
      this.SignPades = {
        request: {
          cert: this.selectedCert,
          document: 'sss',
          profile: 'enhanced',
          extensions: 't,timestamp,revinfo',
          hashalgorithm: '',
          parameters: {
            pdfparameters: {
              signvisible: this.showSignDoc,
              signbackgroundconfig: {
                signback: signImage,
                signbackautostretch: true,
                transparencymask: {
                  red: 255,
                  green: 255,
                  blue: 255,
                  tolerance: 10,
                },
              },
              widgetprops: {},
            },
          },
        },
        metadataDocument: this.metadataDocument,
      };
    }

    if (documentExtension.endsWith('.xml')) {
      this.SignXades = {
        request: {
          cert: this.selectedCert,
          document: 'sss',
          profile: 'enhanced',
          extensions: 't,timestamp,revinfo',
          hashalgorithm: '',
          envelop: '',
          references: [],
          force: false,
          operation: '',
          signdata: '',
        },
        metadataDocument: this.metadataDocument,
      };
    }
  }
}
